import { createTheme } from '@mui/material';
import COLORS from './colors';
// import './theme.styles.scss';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

export const theme = createTheme({
  palette: {
    primary: {
      main: COLORS.PRIMARY.main,
      light: COLORS.PRIMARY.light,
      dark: COLORS.PRIMARY.dark,
      contrastText: COLORS.PRIMARY.contrastText,
    },
    secondary: {
      main: COLORS.SECONDARY.main,
      light: COLORS.SECONDARY.light,
      dark: COLORS.SECONDARY.dark,
      contrastText: COLORS.SECONDARY.contrastText,
    },
    error: {
      main: COLORS.ERROR.main,
      light: COLORS.ERROR.light,
      dark: COLORS.ERROR.dark,
      contrastText: COLORS.ERROR.contrastText,
    },
    warning: {
      main: COLORS.WARNING.main,
      light: COLORS.WARNING.light,
      dark: COLORS.WARNING.dark,
      contrastText: COLORS.WARNING.contrastText,
    },
    info: {
      main: COLORS.INFO.main,
      light: COLORS.INFO.light,
      dark: COLORS.INFO.dark,
      contrastText: COLORS.INFO.contrastText,
    },
    success: {
      main: COLORS.SUCCESS.main,
      light: COLORS.SUCCESS.light,
      dark: COLORS.SUCCESS.dark,
      contrastText: COLORS.SUCCESS.contrastText,
    },
  },
});
